import { useMutation } from '@tanstack/react-query';
import {
  DebtRepaymentSuggestion,
  DebtRepaymentSuggestionRequest,
  suggestDebtRepaymentPlan,
} from '@vgrubs/components';

/**
 * The AI's repayment plan for a location.
 *
 * A mutation rather than a query on purpose, like the vTablet fee
 * suggestion: every click has to be a fresh answer for the target and the
 * amounts on the form right then, and each one is seconds of paid AI work,
 * so it must never fire on its own - not on a remount, a window focus or a
 * retry policy. `mutate()` is the only trigger.
 */
export const useRepaymentPlanSuggestion = (locationId: number) =>
  useMutation({
    mutationFn: async (
      body: DebtRepaymentSuggestionRequest
    ): Promise<DebtRepaymentSuggestion> => {
      const { data } = await suggestDebtRepaymentPlan(locationId, body);
      return data.data;
    },
  });
